import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';

const useStyles = makeStyles(() => ({
    '@keyframes float1': {
        '0%, 100%': {
            transform: 'translate(0, 0) scale(1)',
        },
        '33%': {
            transform: 'translate(10px, -15px) scale(1.05)',
        },
        '66%': {
            transform: 'translate(-8px, 10px) scale(0.95)',
        },
    },
    '@keyframes float2': {
        '0%, 100%': {
            transform: 'translate(0, 0) scale(1)',
        },
        '33%': {
            transform: 'translate(-12px, 12px) scale(0.95)',
        },
        '66%': {
            transform: 'translate(15px, -10px) scale(1.05)',
        },
    },
    spheresContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '200px',
        overflow: 'hidden',
        pointerEvents: 'none',
    },
    sphere: {
        position: 'absolute',
        borderRadius: '50%',
    },
    smallSphere: {
        width: '120px',
        height: '120px',
        bottom: '-40px',
        left: '5%',
        animation: '$float1 8s ease-in-out infinite',
    },
    bigSphere: {
        width: '180px',
        height: '180px',
        bottom: '-60px',
        left: '55%',
        animation: '$float2 10s ease-in-out infinite',
    },
}));

// Define sphere variants
const SMALL_SPHERES = [
    {
        id: 'small1',
        background: 'linear-gradient(to right, #FFEF5E, #F7936F)',
    },
    {
        id: 'small2',
        background: 'linear-gradient(to right, #FF6B9D, #C06C84)',
    },
];

const BIG_SPHERES = [
    {
        id: 'big1',
        background: 'linear-gradient(to right, #0017d6, #8DEDF7)',
    },
    {
        id: 'big2',
        background: 'linear-gradient(to right, #11998e, #38ef7d)',
    },
];

const AnimatedSpheres = () => {
    const classes = useStyles();

    // Randomly select one small and one big sphere
    const selectedSpheres = useMemo(() => {
        const smallIndex = Math.floor(Math.random() * SMALL_SPHERES.length);
        const bigIndex = Math.floor(Math.random() * BIG_SPHERES.length);

        return {
            small: SMALL_SPHERES[smallIndex],
            big: BIG_SPHERES[bigIndex],
        };
    }, []);

    return (
        <Box className={classes.spheresContainer}>
            <Box
                className={`${classes.sphere} ${classes.smallSphere}`}
                style={{ background: selectedSpheres.small.background }}
            />
            <Box
                className={`${classes.sphere} ${classes.bigSphere}`}
                style={{ background: selectedSpheres.big.background }}
            />
        </Box>
    );
};

export default AnimatedSpheres;